const images = {
  logoInline: require('./images/logo-inline.png'),
  howItWorks: require('./images/howItWorks.png')
}

export default images
